import { useCallback, useMemo } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { matchPath, useLocation } from 'react-router-dom'

import LineExclamationCircleIcon from 'LuxKit/Icons/line/LineExclamationCircleIcon'
import SolidTimesCircleIcon from 'LuxKit/Icons/solid/SolidTimesCircleIcon'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { getTripURL } from 'tripPlanner/utils'

export const updateSavedItemMessages = defineMessages({
  updateSuccessful: {
    id: 'icoWDEs-W9a1sfu-qau0',
    defaultMessage: 'Update successful',
    description: 'Default success snackbar message after updating a saved trip item',
  },
})

export const useUpdateSavedItemBookmarkHandlers = () => {
  const intl = useIntl()
  const { pathname } = useLocation()
  const isAlreadyOnTrip = useMemo(
    () =>
      !!matchPath({ path: '/:regionCode/trip-planner/trip/:tripId/:tab', end: false }, pathname),
    [pathname],
  )

  const defaultUpdateMessage = intl.formatMessage(updateSavedItemMessages.updateSuccessful)
  const viewLabel = intl.formatMessage({
    id: 'JVg4lt4kdTgwAz0nkDxg',
    defaultMessage: 'View',
    description: 'Snackbar action label to view the trip after updating a saved item',
  })

  const showUpdateSuccessSnackbar = useCallback(
    (message: string, tripId: string, itemId: string) =>
      showSnackbar(message, 'neutral', {
        icon: <LineExclamationCircleIcon colour="normal-contrast" />,
        action: !isAlreadyOnTrip ?
            {
              label: viewLabel,
              to: getTripURL(tripId, itemId),
            } :
          undefined,
      }),
    [isAlreadyOnTrip, viewLabel],
  )

  const showUpdateErrorSnackbar = useCallback(
    () =>
      showSnackbar(intl.formatMessage({
        id: 'VIWHsONFw2LjdgKnI-rB',
        defaultMessage: 'Failed to update saved offer',
        description: 'Error snackbar message when updating a saved trip offer fails',
      }), 'critical', {
        icon: <SolidTimesCircleIcon colour="critical" />,
      }),
    [intl],
  )

  return {
    defaultUpdateMessage,
    showUpdateSuccessSnackbar,
    showUpdateErrorSnackbar,
  }
}
